export const useBookingVerificationData = () => {
  const nuxtApp = useNuxtApp()

  return useState('bookingVerificationData', () => {
    return import.meta.server ? nuxtApp.ssrContext?.event.context.bookingVerificationDataResponse : null
  })
}
